import { useQuery } from "@tanstack/react-query";
import { getTargetareSnapshotDiferente } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareSnapshotDiferente(id: number | null) {
  return useQuery({
    queryKey: queryKeys.targetare.snapshotDiferente(id ?? 0),
    queryFn: () => getTargetareSnapshotDiferente(id ?? 0),
    select: (response) => response.data,
    enabled: id !== null,
    staleTime: 1000 * 15,
    retry: 1,
  });
}
